<template>
    <div>
        <report-chard
            v-if="typeReport === 'status'"
            class="p-2"
            :module="module" />
        <report-card-chard
            v-else-if="typeReport === 'statistical'"
            class="p-2"
            :module="module" />
        <report-detail-table
            v-else
            class="p-2"
            :module="module" />
    </div>
</template>

<script lang="ts" setup>
import ReportCardChard from './report-card-chart.vue'
import ReportChard from './report-chart.vue'
import ReportDetailTable from './report-detail-table.vue'
const props = defineProps({
  module: {
    type: String,
    required: true
  },
  typeReport: {
    type: Object,
    required: true
  }
})

const { module, typeReport } = toRefs(props)
</script>
